import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const OnHold: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.6px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0002 5.8C6.94715 5.8 6.89628 5.82107 6.85877 5.85858C6.82127 5.89608 6.8002 5.94695 6.8002 6V18C6.8002 18.053 6.82127 18.1039 6.85877 18.1414C6.89628 18.1789 6.94715 18.2 7.0002 18.2H9.0002C9.05324 18.2 9.10411 18.1789 9.14162 18.1414C9.17912 18.1039 9.2002 18.053 9.2002 18V6C9.2002 5.94695 9.17912 5.89608 9.14162 5.85858C9.10411 5.82107 9.05324 5.8 9.0002 5.8H7.0002ZM5.7274 4.7272C6.06497 4.38964 6.5228 4.2 7.0002 4.2H9.0002C9.47759 4.2 9.93542 4.38964 10.273 4.7272C10.6106 5.06477 10.8002 5.52261 10.8002 6V18C10.8002 18.4774 10.6106 18.9352 10.273 19.2728C9.93542 19.6104 9.47758 19.8 9.0002 19.8H7.0002C6.52281 19.8 6.06497 19.6104 5.7274 19.2728C5.38984 18.9352 5.2002 18.4774 5.2002 18V6C5.2002 5.52261 5.38984 5.06477 5.7274 4.7272ZM15.0002 5.8C14.9472 5.8 14.8963 5.82107 14.8588 5.85858C14.8213 5.89608 14.8002 5.94695 14.8002 6V18C14.8002 18.053 14.8213 18.1039 14.8588 18.1414C14.8963 18.1789 14.9472 18.2 15.0002 18.2H17.0002C17.0532 18.2 17.1041 18.1789 17.1416 18.1414C17.1791 18.1039 17.2002 18.053 17.2002 18V6C17.2002 5.94695 17.1791 5.89608 17.1416 5.85858C17.1041 5.82107 17.0532 5.8 17.0002 5.8H15.0002ZM13.7274 4.7272C14.065 4.38964 14.5228 4.2 15.0002 4.2H17.0002C17.4776 4.2 17.9354 4.38964 18.273 4.7272C18.6106 5.06477 18.8002 5.52261 18.8002 6V18C18.8002 18.4774 18.6106 18.9352 18.273 19.2728C17.9354 19.6104 17.4776 19.8 17.0002 19.8H15.0002C14.5228 19.8 14.065 19.6104 13.7274 19.2728C13.3898 18.9352 13.2002 18.4774 13.2002 18V6C13.2002 5.52261 13.3898 5.06477 13.7274 4.7272Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default OnHold;
